import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import { goodsReceiptPalletsSearchSchema } from "@/screens/WarehouseReceiving/schemas"
import { StoredGoodsReceiptsContainer } from "@/screens/WarehouseReceiving/subfeatures/Stored/components"

export const Route = createFileRoute("/app/warehouse-receiving/_layout/stored")({
  validateSearch: zodValidator(goodsReceiptPalletsSearchSchema),
  component: () => <StoredGoodsReceiptsContainer />,
})
